import React from 'react';

interface Props {
    onPointerDown: (event: React.PointerEvent<HTMLDivElement>) => void
}

const ProomTableWindowResizeHandle = ({onPointerDown}: Props): React.ReactElement => <div
    aria-label="Resize table"
    className="proom-widget-resize-handle"
    data-no-drag="true"
    onPointerDown={onPointerDown}
    role="separator"
/>;

export default ProomTableWindowResizeHandle;
